
import React from 'react';
import './App.css';
import RouterComponents from './RouterComponents';
import { BrowserRouter } from 'react-router';

function App() {
  return (
    <BrowserRouter>
      <RouterComponents />
    </BrowserRouter>
  );
}

export default App;
